import {productdata} from '../config/env';
import * as rootypes from '../store/mutations_type'
import { getProduct } from './api'


/**
 * is Chinses
 */
export const isch = str => {
  let realLength = 0, len = str.length, charCode = -1
  for (let i = 0; i < len; i++) {
    charCode = str.charCodeAt(i)
    if (charCode >= 0 && charCode <= 128) realLength += 1
    else realLength += 2
  }
  if (realLength == (str.length) * 2) {
    return true
  } else {
    return false
  }
}

/**
 * puid
 */
export const puidtotitle = puid => {
  return productdata.find(x => x.value === puid).text
}

/**
 * alertmodel
 */

export const alertModel = async (target,title,text) => {

  await target.$bvModal.msgBoxOk(text, {
    title: title,
    size: 'sm',
    buttonSize: 'sm',
    okVariant: 'success',
    headerClass: 'p-2 border-bottom-0',
    footerClass: 'p-2 border-top-0',
    okTitle: '確定',
    centered: true
  })
    .then(value => {
      return Promise.resolve("gwegwegwg");
    })
    .catch(err => {
      return Promise.reject();
    })


}

/**
 * toasts
 */

export const toastsModel = (target,msg) => {
  target.$bvToast.toast(msg, {
    toaster: ' Toast b-toaster-top-center body content',
    variant: 'danger',
    toastClass:'border-0',
    headerClass:'bg-danger text-white',
    bodyClass:'bg-danger text-white',
    href: '#foo',
    // title: title,
    autoHideDelay:1300,
    noCloseButton:true,
    solid: true
  })

}

/**
 * toCurrency
 */


export const toCurrency = num => {
  let parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

/**
 * MediaPlay
 */
export const playSound = () => {
  let audio = new Audio(require('@/assets/media/magic.mp3'));
  audio.play();
  audio.addEventListener("ended", function(){

  });

}

export const fnTime = (time) => {

  let ptime = new Date(time).getTime()

  const twentyFourHours = 24 * 60 * 60 * 1000;
  const fortyEightHours = 24 * 60 * 60 * 1000 * 2;
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const today = `${year}-${month}-${day}`;
  const todayTime = new Date(today).getTime();
  const yesterdayTime = new Date(todayTime - twentyFourHours).getTime();
  const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime();

  if( ptime >= todayTime ){
    return '今天 '+time.split(' ')[1];
  }
  else if( ptime < todayTime && yesterdayTime <= ptime ){
    return '昨天 '+time.split(' ')[1];
  }
  else if( ptime < yesterdayTime && lastYesterdayTime <= ptime ){
    return '前天 '+time.split(' ')[1];
  }
  else{
    return time;
  }
}
